const Users = () => import('@/modules/users/views/Users.vue')

export const usersRoutes = [
	{
		path: '/users',
		component: Users,
		children: [{ name: 'users', path: '/' }, { name: 'cleaners', path: 'cleaners' }]
	}
]
